import * as React from 'react';
import {
  AxisBottom as StyledAxisBottom,
  AxisBottomProps as StyledAxisBottomProps,
} from '../primitives/AxisBottom';
import { useChart } from '../providers/chart-data-provider';

export type AxisBottomProps = Omit<StyledAxisBottomProps, 'top' | 'scale'> & {
  onHeightChange?: (height: number) => void;
};

export function AxisBottom({ onHeightChange, ...props }: AxisBottomProps) {
  const { xScale, yMax } = useChart();
  const bottomAxisRef = React.useRef<SVGTextElement>(null);
  const [currentHeight, setCurrentHeight] = React.useState<number>();

  React.useLayoutEffect(() => {
    if (bottomAxisRef.current?.getBBox && onHeightChange) {
      const { height } = bottomAxisRef.current.getBBox();
      if (currentHeight !== height) {
        setCurrentHeight(height);
        onHeightChange(height);
      }
    }
  }, [currentHeight, onHeightChange]);

  return (
    <StyledAxisBottom
      innerRef={bottomAxisRef}
      top={yMax} // Positions the bottom axis at the bottom of the chart.
      scale={xScale}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
